<template >

  <div  class="single-row" :style="{boxShadow: `inset 0 0 20px ${item.highlightColor ? item.highlightColor : '#fff'}`}" :class="{hasGroup: localItem.groupHash, blurIt: !isActiveGroup}">
     
     <span v-if="processedByCj" class="extra-tag" title="CJ Dropshipping">
        CJ
     </span>

     <a href="#" @click.prevent="accessDraft(localItem.ParentOrder.order_no, localItem.shopifyOrderId)" v-tooltip.top-start="`Parent Order Designs & Drafts History`" class="filesDraftPreview"><i class="fa fa-file-image-o" aria-hidden="true"></i></a>

     
     
     <group-indicator-in-item-list v-if="localItem.groupHash" :group-hash="localItem.groupHash" :grouped-by="localItem.GroupedBy"/>
     <div class="selector" :class="{selected: localItem.selected}" @click="addToSelection(localItem.id)">
       <i class="fa fa-check" aria-hidden="true" ></i>
     </div>
     <div class="remove">
       <i class="fa fa-close" aria-hidden="true" @click="removeFromList"></i>
     </div>
     <b-row>
       <b-col cols="2">
         
         <span v-if="isUpgradedOrder" class="upgradedOrder" title="Upgraded Order">U</span>
         <strong>{{ localItem.orderNoWithPrefix }} </strong>
         <span class="details-trigger"><i class="fa" :class="{'fa-chevron-down': !showDetails, 'fa-chevron-up': showDetails}" @click="showDetails = !showDetails" aria-hidden="true"></i></span>
         <div class="totalItems">
            Items in order: {{ localItem.ParentOrder.ShopifyOrderItems.length }}
         </div>
       </b-col>
       <b-col cols="4">
         <div class="trigger" v-tooltip.top-start="tooltipTxt">
          <input type="text" v-model="localItem.sizeOrType" class="column-field" @change="updateSingleValue('sizeOrType', localItem.sizeOrType)">
         </div>
       </b-col>
       <b-col cols="3">
           
           <item-list-upload-download-widget :item-id="localItem.id" :cdr-file-link-prop="localItem.cdrFileLink" :image-grid-link-prop="localItem.imageGridLink" />
            
       </b-col>
       <b-col cols="3" class="">
          <div class="float-right item-quantity">Item Quantity: <span>{{ localItem.ParentItem.quantity }}</span></div>
          <print-statuses :item-id="localItem.id" :print-file-sent="localItem.printFileSent" :print-file-checked="localItem.printFileChecked" :print-file-printed="localItem.printFilePrinted"/>
       </b-col>
     </b-row>
     

     <div class="m-t-5">
       <b-row>
         <b-col cols="8">
            <colorize-item-in-list :item-id="item.id" :highlighted-by="item.HighlightedByUser ? item.HighlightedByUser.username : ''" />
            <span v-if="item.isDuplicate == 'yes'" class="duplicateIndicator">Duplicate</span>


            <b-btn :variant="showFiles ? 'success' :  'default'" @click="showFiles = !showFiles"  v-if="approvedFiles.length > 0" size="xs" class="m-l-10"><b-icon icon="download" aria-hidden="true"  ></b-icon> Approved Files</b-btn>

            <div class="designerName" v-if="assignedDesignerName">
              Desgr: {{ assignedDesignerName }}
            </div>
         </b-col>
         <b-col cols="4 " class="text-right">
            <div class="meta"><span>On: </span>{{ localItem.createdAt  | moment("Do MMM YYYY, h:mm:ss a") }}</div>

            <div class="meta m-l-10">
              <span>By: </span>{{ localItem.WhoAdded ? localItem.WhoAdded.username : "unknown" }}
            </div>
         </b-col>
       </b-row>
     </div>

     <transition name="fade">
        <details-item-list v-if="showDetails" :item="localItem"/>
    </transition>       
     <transition name="fade">
       <approved-design-widget :approved-files="approvedFiles" v-if="showFiles"/>
    </transition>       
     
    <div class="single-item-in-list-full-name">
            <strong>Product Info. :</strong> {{tooltipTxt}}
    </div>

    <section class="coutriesInfoAndTags">
      <b-row>
        <b-col cols="7">
           <div class="countryInfo" >Ship From: <span class="countryInfoTag" @click="showCountrySetter = !showCountrySetter">
                {{ localItem.ShippedFromCountry ? localItem.ShippedFromCountry.name : "Not Set"}}
             </span> 
     
             Ship To:
           <span class="countryInfoTag">
              {{ localItem.ParentOrder.customerData.default_address && localItem.ParentOrder.customerData.default_address.country ? localItem.ParentOrder.customerData.default_address.country : "Unknown"}}
          </span>
        </div>
        <set-country-print-queue v-if="showCountrySetter" :item-list-pk="item.id" />

        <last-selected-country :item-list-pk="item.id"/>
        
        </b-col>
         <b-col cols="5">
            <tag-setter-items-list :tags="item.tags" :item-list-pk="item.id"/>
            
        </b-col> 
      </b-row>
    </section>

   
    

  </div>
</template>

<script>
const PrintStatuses = () => import(/* webpackChunkName: "print-statuses" */ "./print-statuses")
const ColorizeItemInList = () => import(/* webpackChunkName: "colorize-item-in-list" */ "./colorize-item-in-list")
const ItemListUploadDownloadWidget = () => import(/* webpackChunkName: "item-list-upload-download-widget" */ "./item-list-upload-download-widget")
const GroupIndicatorInItemList = () => import(/* webpackChunkName: "item-list.group-indicator" */ "./group-indicator-in-item-list")
const DetailsItemList = () => import(/* webpackChunkName: "details-item-list" */ "./details-item-list")

const ApprovedDesignWidget = () => import(/* webpackChunkName: "approved-design-widget" */ "./approved-design-widget")
const SetCountryPrintQueue = () => import(/* webpackChunkName: "set-country-print-queue" */ "./set-country-print-queue.vue")

const LastSelectedCountry = () => import(/* webpackChunkName: "print-queue.last-selected-country" */ "./last-selected-country.vue")

const TagSetterItemsList = () => import(/* webpackChunkName: "tag-setter-items-list" */ "./tag-setter-items-list.vue");


import ItemListService from '../../services/item-list.service'
import EventBus from '../../EventBus'

  export default {
    components: {PrintStatuses, ColorizeItemInList, ItemListUploadDownloadWidget, GroupIndicatorInItemList, DetailsItemList, ApprovedDesignWidget, SetCountryPrintQueue, LastSelectedCountry, TagSetterItemsList},
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      addToSelection: {
        type: Function,
        default: null
      },
    },
    data(){
      return {
        localItem: Object.assign({}, this.item),
        showDetails: false,
        showFiles: false,
        showCountrySetter: false
      }
    },
    watch:{
      item(newItem){
          console.log('New item', newItem)
          this.localItem= Object.assign({}, newItem)
          this.showCountrySetter = false;
      }
    },
    methods: {
      async removeFromList(){
        this.$dialog
          .confirm('Please confirm to continue')
          .then(async (dialog) => {
              try{
                    const removeStatus = await ItemListService.deleteFromList(this.localItem.id, 'no');

                    this.$toasted.show(removeStatus.data.message, {
                      type: "success",
                      action: {
                        text: "Close",
                        class: "toastBtnTxt",
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0);
                        },
                      },
                      duration: 5000,
                    });

                    EventBus.$emit('item-list.removed-item', this.localItem.id);

                    
                    
                }catch(errors){
                  this.$toasted.show(errors.response.data.message, {
                      type: "error",
                      action: {
                        text: "Close",
                        class: "toastBtnTxt",
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0);
                        },
                      },
                      duration: 5000,
                    });
                }
          })
          .catch(function() {
            console.log('Clicked on cancel');
          });
      },
      async updateSingleValue(column, value){
          try{
              let data = {
                value: value,
                field: column
              }
              const result = await ItemListService.setSingleValue(data, this.localItem.id);

              this.$toasted.show(result.data.message, {
                  type: "success",
                  action: {
                    text: "Close",
                    class: "toastBtnTxt",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                  duration: 5000,
              });

              EventBus.$emit('item-in-list-updated', {id: this.localItem.id, theItem: result.data.theItem})

          }catch(errors){
            console.log(errors)
          }
      },
      accessDraft(orderNo, orderId) {
          
          EventBus.$emit("accessed-customer-draft", { orderNo, orderId });
        }
    },
    computed: {
       tooltipTxt(){
          let txt = this.localItem.ParentItem.name;
          this.localItem.ParentItem.properties.forEach(property => {
             if(property.name == 'Phone Model'){
                txt = `${txt} ( ${property.value} )`
             }
          })

          return txt;
       },
       isUpgradedOrder(){
          if(this.tooltipTxt.toLowerCase().includes('upgrade')){
            return true
          }
          return false;
       },
       isActiveGroup(){
            if(this.$store.state.itemsList.activeGroupHash){
              return this.$store.state.itemsList.activeGroupHash == this.localItem.groupHash
            }
            else{
              return true;
            }
        },
       approvedFiles(){

          let approvedFiles = [];
          if(this.localItem.ParentOrder.CustomerDrafts.length){
             this.localItem.ParentOrder.CustomerDrafts.forEach(draft => {
                draft.DraftFiles.forEach(file => {
                   approvedFiles.push({
                      fileThumbUrl: file.fileInfo.fileThumbUrl,
                      fileUrl: file.fileInfo.fileUrl,
                      approvalStatus: file.approvalStatus
                   })
                })
             })
          }else{
            return []
          }

          return approvedFiles;

       },
       assignedDesignerName(){

          let designerName = '';

          if(this.localItem.ParentOrder.tags){
             const tagsArr = this.localItem.ParentOrder.tags.split(',').map(tag => tag.trim())

             for(const thisTag of tagsArr){
                if(thisTag.toLowerCase().includes('-designer')){
                     designerName = thisTag.replace('-designer', '')
                     break;
                }
             }
          }

          return designerName
       },
       processedByCj(){
         return this.localItem.ParentOrder.tags && this.localItem.ParentOrder.tags.toLowerCase().includes('cj')
       },
    }
  }
</script>

<style lang="scss" scoped>
  .single-row{
    border-bottom: 1px solid rgb(202, 202, 202);
    padding: 10px 10px 5px 10px;
    background-color: #fff; // #F7EE00
    font-size: 14px;
    box-shadow: 1px 1px 5px rgba(175, 175, 175, 0.1);
    margin: 0 30px 3px 30px;
    position: relative;
    transition: all 400ms ease;
    border-radius: 3px;
    .selector{
      position: absolute;
      width: 25px;
      height: 25px;
      background-color: rgb(226, 226, 226);
      border: 1px solid rgb(196, 196, 196);
      text-align: center;
      line-height: 25px;
      left: -30px;
      top: 10px;
      z-index: 20;
      border-radius: 3px 0 0 3px;
      cursor: pointer;

      &.selected{
          background-color: rgb(38, 118, 238);
          color: #fff;
          i{
            color:#fff;
          }
        }

      i{
        color: rgb(201, 201, 201);
      }
    }
  }
  .column-field{
    width: 100px;
    border: 0;
    background-color: transparent;
  }
  
  .custom-btn{
    font-size: 11px;
    padding: 3px 10px;
    background-color: black;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    border-radius: 3px;
    cursor: pointer;
    &.green-custom-btn{
      background-color: rgb(255, 78, 71)
    }
  }
  .remove{
    position: absolute;
    right: -20px;
    top: 10px;
    color: red;
  }
  .downloadOptions {
    .btn-outline-primary{
      border-color: #fff !important;
    }
  }
  .details-trigger{
    font-size: 10px;
    display: inline-block;
    margin-left: 5px;
    cursor: pointer;
    position: relative;
    top: -3px;
    color: rgb(56, 56, 56);
  }
  .duplicateIndicator{
    display: inline-block;
    padding: 1px 3px;
    color: red;
    border: 1px solid red;
    font-size: 11px;
    border-radius: 3px;
    margin-left: 10px;
  }
  .meta{
    font-size: 12px;
    color: rgb(163, 174, 190);
    display: inline-block;
    span{
      color: rgb(79, 84, 92);
    }
  }
  $normalgroup: rgb(107, 128, 153);
  .hasGroup{
    border-left: 1px solid $normalgroup;
  }
  .blurIt{
     /* Add the blur effect */
    filter: blur(3px);
    -webkit-filter: blur(3px);
  }
  .upgradedOrder{
     display: inline-block;
     padding: 0 4px;
     background-color: rgb(14, 206, 148);
     color: #fff;
     font-size: 12px;
     font-weight: 600;
     border-radius: 3px;
     margin-right: 5px;
  }
  .totalItems{
    font-size: 12px;
    color: rgb(170, 170, 170);
  }
  .designerName{
    display: inline-block;
    font-size: 12px;
    margin-left: 5px;
    color: rgb(31, 184, 31);
  }
  .extra-tag{
     position: absolute;
     right: -25px;
     bottom: 10px;
     display: block;
     background-color: orange;
     color: #fff;
     padding: 3px;
     width: 25px;
     text-align: center;
     font-weight: bold;
     border-radius: 0 3px 3px 0;
     font-size: 10px;
     letter-spacing: 2px;
  }
  /* .single-item-in-list-full-name{
     border-bottom: 1px dashed rgb(233, 233, 233);
     padding-bottom: 5px;
     margin-bottom: 10px;
  } */
  .countryInfo{
     font-size: 12px;
  }
  .countryInfoTag{
     padding: 3px 8px;
     display: inline-block;
     background-color: rgb(45, 116, 248);
     color: #fff;
     font-size: 11px;
     border-radius: 5px;
     margin-right: 15px;
     
     &:first-child{
       cursor: pointer;
     }
     &:last-child{
       background-color: rgb(89, 199, 25);
     }
  }

  .coutriesInfoAndTags{
     margin-top: 15px;
     padding-top: 10px;
     padding-bottom: 5px;
     border-top: 1px solid rgb(216, 227, 238);
  }
  $quantity-color: rgb(255, 83, 40);
  .item-quantity{
    font-size: 13px;
    margin-right: 5px;
    color: $quantity-color;
    margin-bottom: 5px;

    span{
      display: inline-block;
      padding: 0px 10px;
      border-radius: 3px;
      background: $quantity-color;
      color: #fff;
    }
  }
  .filesDraftPreview{
    position: absolute;
    right: -15px;
    bottom: 10px;
    color: rgb(89, 199, 38);
  }
</style>